import styled from 'styled-components';
import { layout } from '@prisjakt/ui-base';
import Button from '@prisjakt/ui-button';

export const StoreReviews = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: ${layout.spacing.xxSmall};
`;

export const StoreLink = styled(Button)`
  text-transform: none;
  padding: 0;
`;

export const Separator = styled.span`
  margin: 0 ${layout.spacing.xxSmall};
`;
